// extracted by mini-css-extract-plugin
module.exports = {"locations_warning":"BulkLocationChange_locations_warning__iBbet","locations_button":"BulkLocationChange_locations_button__189mQ"};